import ReviewDetail from './ReviewDetail';
import List from './ReviewList';

const Reviews = {
  list: List,
  show: ReviewDetail,
};

export default Reviews;
